/**
 * FeedbackCtrl controller
 */

/**
 * FeedbackCtrl controller
 *
 * @class FeedbackCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:FeedbackCtrl
 */
/* @ngInject */
export default function FeedbackCtrl ($scope, $http, $uibModalInstance, alertSvc, alertLiteSvc) {
  let vm = this

  /**
   * Object with feedback
   *
   * @memberof mwApp/auth.controller:FeedbackCtrl
   * @type {Object}
   */
  vm.feedback = {
    subject: null,
    content: null,
  }

  vm.fileList = []
  vm.urlList = []
  vm.overallSize = 0

  /**
   * Error message from server
   *
   * @type {String}
   */
  vm.error = null

  /**
   * Perform request feedback
   *
   * @memberof mwApp/auth.controller:FeedbackCtrl
   */
  vm.sendFeedback = function () {
    vm.feedback.attachmentUrls = vm.urlList
    $http.post(`api/feedback`, vm.feedback)
      .then(
        () => {
          vm.error = null
          alertSvc.alert('Your feedback has been successfully submitted', 'success')
          $uibModalInstance.close()
        }
      )
      .catch(
        response => {
          vm.error = 'Error: ' + response.data
          alertSvc.alert(response.data, 'danger')
        }
      )
  }

  /**
   * Upload logo
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @function
   */
  vm.uploadFile = (file) => {
    const url = typeof url === 'string' ? url : 'api/feedback/upload'
    if (file.size > 2097152) {
      $scope.$broadcast('dndfile.clear', true)
      return alertLiteSvc.alert(`Max file size is 2MB`, 'danger')
    }

    let curOverallSize = vm.overallSize + file.size

    if (vm.fileList.length === 10) {
      $scope.$broadcast('dndfile.clear', true)
      return  alertLiteSvc.alert(`Maximum 10 attachments can be uploaded`, 'danger')
    }

    let fd = new window.FormData()
    if (file.hasOwnProperty('value') && file.hasOwnProperty('param')) {
      fd.append(file.param, file.value, file.fileName)
    } else {
      fd.append('file', file)
    }

    // upload file
    return $http.post(url, fd, {

      // Angular’s default transformRequest function will try to serialize FormData object,
      // so we override it with the identity function to leave the data intact
      transformRequest: angular.identity,

      // Angular’s default Content-Type header for POST and PUT requests is application/json,
      // so we want to change this, too.
      // By setting 'Content-Type': undefined, the browser sets the Content-Type to multipart/form-data
      // for us and fills in the correct boundary. Manually setting 'Content-Type': multipart/form-data
      // will fail to fill in the boundary parameter of the request.
      headers: {
        'Content-Type': undefined
      }
    }).then(
      response => {
        if (response.data && response.data.resourceUrl) {
          vm.urlList.push(response.data.resourceUrl)
          vm.fileList.push({index: Math.floor(Math.random() * 1000), name: file.name })
          vm.overallSize = curOverallSize
        }

        $scope.$broadcast('dndfile.clear', true)
      }
    )
      .catch((err) => {
        if (!err.statusText) {
          alertLiteSvc.alert(`External API Error. Code: ${err.status}`, 'danger')
        } else {
          alertLiteSvc.alertError(err)
        }
        $scope.$broadcast('dndfile.clear', true)
      })
  }

  vm.deselectFile = function (index) {
    vm.fileList.splice(index, 1)
    vm.urlList.splice(index, 1)
  }

  /**
   * Close modal window
   *
   * @memberof mwApp/auth.controller:FeedbackCtrl
   */
  vm.close = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
